import React from 'react';

const BodyContentLayout = ({ children, ...rest }) => {
  return (
    <div
      className="flex desktop:flex-row mobile:flex-col mobile:mx-4"
      {...rest}
    >
      {children}
    </div>
  );
};

export default BodyContentLayout;
